/**
 * Stable per-device colors and ordinal labels for chat message attribution.
 *
 * Each device that appears in a conversation gets a color from the palette
 * (assigned in first-seen order, cycling when exhausted) and an ordinal label
 * ("Device 1", "Device 2", …). The mapping lives in a ref-like object owned by
 * the caller, so it stays stable for the lifetime of the page.
 */
export const DEVICE_COLOR_PALETTE = [
    "#4f9cf9", // blue
    "#34c38f", // green
    "#f7b84b", // amber
    "#f1556c", // red
    "#9b7ede", // purple
    "#45c4d6", // teal
    "#e58fb1", // pink
    "#a3b18a", // sage
];
export function createDeviceColorMap() {
    return { order: [] };
}
function indexOf(map, deviceId) {
    let idx = map.order.indexOf(deviceId);
    if (idx === -1) {
        map.order.push(deviceId);
        idx = map.order.length - 1;
    }
    return idx;
}
export function getDeviceColor(map, deviceId) {
    return DEVICE_COLOR_PALETTE[indexOf(map, deviceId) % DEVICE_COLOR_PALETTE.length];
}
/** 1-based ordinal of the device (for "Device N" style labels). */
export function getDeviceOrdinal(map, deviceId) {
    return indexOf(map, deviceId) + 1;
}
